import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForecastTemperaturesDropComponent } from './forecast-temperatures-drop.component';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { ForecastTemperaturesDropRoutingModule } from './forecast-temperatures-drop-routing.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { ChSkeletonComponent } from '../shared/ch-skeleton/ch-skeleton.component';

@NgModule({
  declarations: [ForecastTemperaturesDropComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    MaterialModule,
    CustomTimpickerModule,
    CustomInputModule,
    MatPaginatorModule,
    ExpansionPanelModule,
    ForecastTemperaturesDropRoutingModule,
    PcMultiSelectFilterModule,
    ChSkeletonComponent,
  ],
  exports: [ForecastTemperaturesDropComponent],
})
export class ForecastTemperaturesDropModule {}
